import {
  GET_ALL_CITIES,
  GET_ALL_CITIES_FAILURE,
  GET_ALL_CITIES_SUCCESS,
  GET_ALL_COUNTRIES,
  GET_ALL_COUNTRIES_FAILURE,
  GET_ALL_COUNTRIES_SUCCESS,
  GET_ALL_CURRENCIES,
  GET_ALL_CURRENCIES_FAILURE,
  GET_ALL_CURRENCIES_SUCCESS,
  GET_ALL_ROLES,
  GET_ALL_ROLES_FAILURE,
  GET_ALL_ROLES_SUCCESS,
} from "./actionTypes";

//countries
export const getAllCountries = (payload) => {
  return {
    type: GET_ALL_COUNTRIES,
    payload: payload,
  };
};

export const getAllCountriesSuccess = (payload) => {
  return {
    type: GET_ALL_COUNTRIES_SUCCESS,
    payload: payload,
  };
};

export const getAllCountriesFailure = (error) => {
  return {
    type: GET_ALL_COUNTRIES_FAILURE,
    payload: error,
  };
};

//currencies
export const getAllCurrencies = (payload) => {
  return {
    type: GET_ALL_CURRENCIES,
    payload: payload,
  };
};

export const getAllCurrenciesSuccess = (payload) => {
  return {
    type: GET_ALL_CURRENCIES_SUCCESS,
    payload: payload,
  };
};

export const getAllCurrenciesFailure = (error) => {
  return {
    type: GET_ALL_CURRENCIES_FAILURE,
    payload: error,
  };
};

//cities
export const getAllCities = (payload) => {
  return {
    type: GET_ALL_CITIES,
    payload: payload,
  };
};

export const getAllCitiesSuccess = (payload) => {
  return {
    type: GET_ALL_CITIES_SUCCESS,
    payload: payload,
  };
};

export const getAllCitiesFailure = (error) => {
  return {
    type: GET_ALL_CITIES_FAILURE,
    payload: error,
  };
};

// Role
export const getAllRoles = (payload) => {
  return {
    type: GET_ALL_ROLES,
    payload: payload,
  };
};

export const getAllRolesSuccess = (payload) => {
  return {
    type: GET_ALL_ROLES_SUCCESS,
    payload: payload,
  };
};

export const getAllRolesFailure = (error) => {
  return {
    type: GET_ALL_ROLES_FAILURE,
    payload: error,
  };
};
